import {helpers} from "vuelidate/lib/validators";
import {isValidPinfl} from "@/shared/pinfl-birthdate/pinfl-birthdate";

/*Note! 'param' is used when pinfl field is using with optional requirement. 'param' need to set 'requredUnless' returning value.
For example:
a) with 'requiredUnless':
    pinfl: {
        required: requiredUnless(() => {
            return this.ownerType === 'Legal'
        }),
        pinflNumber: pinflNumber(this.ownerType === 'Legal')
    }
b) with 'required':
    pinfl: {
        required: required,
        pinflNumber: pinflNumber()
    }
*/
export const pinflNumber = param => helpers.withParams(
    { type: 'pinflNumber' },
    (value) => param ? true : isValidPinfl(value).result
)
